export const filterAndSelectProducts = (allProdPlans, affiliate_id) => {
    // Step 1: Group products by their ID
    const groupedProducts = allProdPlans.reduce((acc, product) => {
      (acc[product.products_id] = acc[product.products_id] || []).push(product);
      return acc;
    }, {});
  
    // Step 2: Filter and select products based on the conditions
    const filteredProducts = Object.values(groupedProducts).flatMap(products => {
      // Case when affiliate_id is present
      if (affiliate_id !== null) {
        const affiliateMatchedProducts = products.filter(product =>
          product.affiliates && product.affiliates.includes(affiliate_id)
        );
  
        // If one or more products match the affiliate_id, keep only those
        if (affiliateMatchedProducts.length > 0) {
          return affiliateMatchedProducts;
        }
  
        // If no products match the affiliate_id, keep products without any affiliates
        const noAffiliateProducts = products.filter(product =>
          !product.affiliates || product.affiliates.length === 0
        );
  
        if (noAffiliateProducts.length > 0) {
          return noAffiliateProducts;
        }
      } else {
        // Case when affiliate_id is null: prioritize products without any affiliates
        const noAffiliateProducts = products.filter(product =>
          !product.affiliates || product.affiliates.length === 0
        );
  
        // If there are noAffiliateProducts, return them; else, all products are to be removed
        if (noAffiliateProducts.length > 0) {
          return noAffiliateProducts;
        }
      }
  
      // If no suitable products are found based on the above conditions, return an empty array to indicate removal
      return [];
    });
  
    return filteredProducts;
  };
  
  
  